import PointBubble from './PointBubble';

export default PointBubble;
